import React from 'react';
import { Icon } from 'antd';

const optionsDefault = {
  okText: 'Готово',
  icon: <Icon type="check-circle" theme="filled" />,
  closable: false,
  maskClosable: true,
  centered: true,
  className: 'employee-success-form',
  onOk() {},
  onCancel() {},
};

export const successProfileUpdation = data => ({
  ...optionsDefault,
  title: 'Данные Вашего профиля успешно изменены!',
  content: `Данные профиля ${data} успешно изменены.`,
});
